/* eslint-disable react-hooks/exhaustive-deps, react/forbid-component-props */
import { faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useContext } from 'react';
import { ORDER_SUMMARY } from '../../../brands/default/content/components/checkout';
import ThemeContext from '../../../providers/ThemeProvider';
import { SlideAnimation } from '../../_generic/animation';
import Tile from '../../_generic/tile/Tile';
import TileBody from '../../_generic/tile/TileBody';
import VipDurationMessage from '../payment/VipDurationMessage';
import Credit from './Credit';
import Promo from './Promo';
import RedeemCode from './RedeemCode';
import Summary from './Summary';
import VoucherValidityExtension from './VoucherValidityExtension';

const OrderSummary = ({
  bt,
  currencySymbol,
  handleCreditClick,
  handlePromoClick,
  handleRemovePromoClick,
  hasCreditInSameCurrency,
  hasError,
  hasLoadingSpinner,
  finalOrderAmount,
  isAuthenticated,
  isCheckout = false,
  isDisabledCheck,
  isExclusiveProductInBasket,
  isGiftClaim = false,
  isGiftClaimable,
  isVipUser,
  isWalletAllowed,
  orderSummary,
  paymentOptions,
  promoCode,
  redeemCreditOnComplete,
  setVipOptIn,
  vipCheckboxEnabled,
  vipOneYearPrice,
  vipOptIn,
  vipOptInFinalOrderAmount,
  basketDiscountForExistingVipUser,
  userVipStatus,
  vipOptInTotalWalletAmount,
  vipOptInTotalWalletApplicableOrderAmount,
  vipOptInType,
  vipSubscriptionDetails,
  vipSummary,
  vveSummary,
  wallet,
  welcomeVipEnabled,
}) => {
  const theme = useContext(ThemeContext);
  const [hasAnimation, setHasAnimation] = useState(false);
  const [vipCanShowCheckbox, setVipCanShowCheckbox] = useState(false);

  const getVipDiscountMessage = () => {
    if (!welcomeVipEnabled || isVipUser) return null;

    const months = vipSummary?.vipOptInSubscription?.vipOptInValidity;

    if (!months) return null;

    return <VipDurationMessage months={months} />;
  };

  const getVipCanShowCheckbox = () => {
    let value = false;
    if (
      vipCheckboxEnabled &&
      isAuthenticated &&
      isVipUser === false &&
      vipSubscriptionDetails
    ) {
      value = true;
    } else {
      setVipOptIn(false);
    }

    return value;
  };

  useEffect(() => {
    setVipCanShowCheckbox(getVipCanShowCheckbox());
  }, [vipCheckboxEnabled]);

  useEffect(() => {
    const onScroll = () => {
      setHasAnimation(true);
      window.removeEventListener('scroll', onScroll);
    };
    window.addEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="order-summary">
      <Tile extraClasses="order-summary" title={ORDER_SUMMARY.title}>
        <TileBody nobackground>
          <div className="order-summary__body">
            <div className="order-summary__col-promo">
              <Promo
                errorMsg={promoCode.message}
                handlePromoClick={handlePromoClick}
                handleRemovePromoClick={handleRemovePromoClick}
                hasError={hasError}
                isAuthenticated={isAuthenticated}
                isDisabled={isDisabledCheck}
                isValidPromo={promoCode.applicable}
                validCode={promoCode.value}
                validMsg={promoCode.message}
              />
              <Credit
                currency={orderSummary?.currency}
                currencySymbol={currencySymbol}
                handleCreditClick={handleCreditClick}
                hasCreditInSameCurrency={hasCreditInSameCurrency}
                isGiftClaim={isGiftClaim}
                isGiftClaimable={isGiftClaimable}
                isWalletAllowed={isWalletAllowed}
                paymentOptions={paymentOptions}
                promoCodeIsApplied={promoCode.applicable}
                totalWalletApplicableOrderAmount={
                  orderSummary.totalWalletApplicableOrderAmount
                }
                vipOptInTotalWalletApplicableOrderAmount={
                  vipOptInTotalWalletApplicableOrderAmount
                }
                walletIsApplied={wallet}
              />
              {isAuthenticated && (
                <RedeemCode
                  creditBalances={paymentOptions?.creditBalances}
                  currency={orderSummary?.currency}
                  hasLoadingSpinner={hasLoadingSpinner}
                  isWalletAllowed={isWalletAllowed}
                  paymentOptions={paymentOptions}
                  redeemCreditOnComplete={redeemCreditOnComplete}
                  totalWalletApplicableOrderAmount={
                    orderSummary.totalWalletApplicableOrderAmount
                  }
                  walletIsApplied={wallet}
                />
              )}
              {isAuthenticated && vveSummary?.length > 0 && (
                <VoucherValidityExtension
                  bt={bt}
                  creditBalances={paymentOptions?.creditBalances}
                  currency={orderSummary.currency}
                  hasLoadingSpinner={hasLoadingSpinner}
                  isCheckout={isCheckout}
                  isWalletAllowed={isWalletAllowed}
                  paymentOptions={paymentOptions}
                  redeemCreditOnComplete={redeemCreditOnComplete}
                  totalWalletApplicableOrderAmount={
                    orderSummary.totalWalletApplicableOrderAmount
                  }
                  vveSummary={vveSummary}
                  walletIsApplied={wallet}
                />
              )}
            </div>
            <div className="order-summary__col-summary">
              <Summary
                {...orderSummary}
                basketDiscountForExistingVipUser={
                  basketDiscountForExistingVipUser
                }
                currencySymbol={currencySymbol}
                discount={promoCode.discount}
                finalOrderAmount={finalOrderAmount}
                isExclusiveProductInBasket={isExclusiveProductInBasket}
                setVipOptIn={setVipOptIn}
                userVipStatus={userVipStatus}
                vipCanShowCheckbox={vipCanShowCheckbox}
                vipDiscountMessage={getVipDiscountMessage()}
                vipOneYearPrice={vipOneYearPrice}
                vipOptIn={vipOptIn}
                vipOptInBasketDiscount={
                  vipSummary?.vipOptInSubscription?.vipOptInBasketDiscount
                }
                vipOptInFinalOrderAmount={vipOptInFinalOrderAmount}
                vipOptInPrice={vipSummary?.vipOptInSubscription?.vipOptInPrice}
                vipOptInSubscription={vipSummary?.vipOptInSubscription}
                vipOptInTotalWalletAmount={vipOptInTotalWalletAmount}
                vipOptInType={vipOptInType}
                vipSubscriptionDetails={vipSubscriptionDetails}
                welcomeVipEnabled={welcomeVipEnabled}
              />
            </div>
          </div>
          {hasAnimation && (
            <SlideAnimation>
              <div className="alert">
                <FontAwesomeIcon
                  className="alert__arrow-icon"
                  icon={faAngleDoubleUp}
                />
                <span>{ORDER_SUMMARY.socialCuesMayIncrease}</span>
                <FontAwesomeIcon
                  className="alert__arrow-icon"
                  icon={faAngleDoubleUp}
                />
              </div>
            </SlideAnimation>
          )}
        </TileBody>
      </Tile>
      <style jsx>{`
        .order-summary {
          padding-bottom: 30px;
        }
        .order-summary__body {
          display: flex;
          padding: 5px 0;
        }
        .order-summary__col-promo,
        .order-summary__col-summary {
          width: 50%;
        }
        .order-summary__col-promo {
          border-right: 1px solid #ccc;
          padding: 0 30px 0 0;
        }
        .order-summary__col-summary {
          padding: 0 0 0 45px;
        }
        .alert {
          font-weight: bold;
          font-size: 14px;
          padding: 15px 0;
          position: relative;
          background: #ffff9d;
          margin: 10px -15px -15px -15px;
          border-radius: 0 0 7px 7px;
          text-align: center;
          display: block;
        }
        .alert :global(.alert__arrow-icon) {
          width: 14px;
          height: 14px;
          color: #eb3f3c;
          vertical-align: middle;
          margin: 0 5px;
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .order-summary {
            padding-bottom: 0;
          }
          .order-summary :global(.tile-body) {
            padding: 0;
          }
          .order-summary__body {
            display: block;
          }
          .order-summary__col-promo,
          .order-summary__col-summary {
            width: 100%;
            padding: 15px;
          }
          .order-summary__col-promo {
            border-right: none;
            padding: 15px;
            border-bottom: 2px solid ${theme.colors.primary};
          }
          .alert {
            margin: 0;
          }
        }
      `}</style>
    </div>
  );
};

OrderSummary.propTypes = {
  basketDiscountForExistingVipUser: PropTypes.number,
  bt: PropTypes.string,
  currencySymbol: PropTypes.string,
  finalOrderAmount: PropTypes.number,
  handleCreditClick: PropTypes.func,
  handleCreditRedirect: PropTypes.func,
  handlePromoClick: PropTypes.func,
  handleRemovePromoClick: PropTypes.func,
  hasCreditInSameCurrency: PropTypes.bool,
  hasError: PropTypes.bool,
  hasLoadingSpinner: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  isCheckout: PropTypes.bool,
  isDisabledCheck: PropTypes.bool,
  isExclusiveProductInBasket: PropTypes.bool,
  isGiftClaim: PropTypes.bool,
  isGiftClaimable: PropTypes.bool,
  isVipUser: PropTypes.bool,
  isWalletAllowed: PropTypes.bool,
  orderSummary: PropTypes.object.isRequired,
  paymentOptions: PropTypes.object,
  promoCode: PropTypes.object.isRequired,
  redeemCreditOnComplete: PropTypes.func,
  setVipOptIn: PropTypes.func,
  userVipStatus: PropTypes.string,
  vipCheckboxEnabled: PropTypes.bool,
  vipOneYearPrice: PropTypes.number,
  vipOptIn: PropTypes.bool,
  vipOptInFinalOrderAmount: PropTypes.number,
  vipOptInTotalWalletAmount: PropTypes.number,
  vipOptInTotalWalletApplicableOrderAmount: PropTypes.number,
  vipSubscriptionDetails: PropTypes.object,
  wallet: PropTypes.bool,
  welcomeVipEnabled: PropTypes.bool,
};

OrderSummary.defaultProps = {
  handleCreditClick: () => {},
  handleCreditRedirect: () => {},
  handlePromoClick: () => {},
  handleRemovePromoClick: () => {},
  hasLoadingSpinner: () => {},
  redeemCreditOnComplete: () => {},
};

export default OrderSummary;
